import React, {Fragment} from "react";
import mus_entry from "./mus_entry";
import MusCatEntry from "./MusCatEntry";
import MusCategories from "./MusCategories";
import {isObjectEmpty} from "../../../../../../../../helpers/tools";


const categories_serializer = (categories) => {
    const categ_serializer = {}
    const total_categ_serializer = {
        total_client_cost: 0,
        total_estro_cost: 0
    }

    categories.forEach((item) => {
        const client = parseFloat(item.client_cost);
        const estro = parseFloat(item.estro_cost);

        const data = {
            id: item.id,
            title: item.title,
            client_cost: item.client_cost,
            estro_cost: item.estro_cost,
        };
        // grupowanie po kategorii
        if (categ_serializer[item.categorie]) {
            categ_serializer[item.categorie].push(data);
        } else {
            categ_serializer[item.categorie] = [data];
        }
        // sumowanie globalne (na liczbach wg muzyków)
        total_categ_serializer.total_client_cost += client;
        total_categ_serializer.total_estro_cost += estro;
    });

    total_categ_serializer.total_client_cost = total_categ_serializer.total_client_cost.toFixed(2);
    total_categ_serializer.total_estro_cost = total_categ_serializer.total_estro_cost.toFixed(2);

    return { categ_serializer, total_categ_serializer };
}


const AdditionalMusicianItem = ({musician, index, handlePopup, changeHandler}) => {
    const categories_data = categories_serializer(musician.categories);

    return (<>
        { mus_entry(musician, index, handlePopup, categories_data.total_categ_serializer) }

        { Object.keys(categories_data).length > 0
            ?(<>
                {Object.keys(categories_data.categ_serializer).map((key, key_index) => (
                    <Fragment key={"entry_" + key_index} >
                        <MusCategories categories_name={key} />

                        <MusCatEntry
                            data={categories_data.categ_serializer[key]}
                            changeHandler={changeHandler}
                            musician_id={musician.musician_id}
                        />

                    </Fragment>
                ))}
            </>)
            : null
        }
    </>)
}


export default AdditionalMusicianItem;
